import React from "react";

export default function SQLServer_MONTH() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_MONTH</h1>
      <p>This is the SQLServer_MONTH component generated from the SQL JSON.</p>
    </div>
  );
}
